import { usePassThrough } from 'primevue/passthrough';

export const preset = usePassThrough(
  {
    pcpaginator: {
      root: {
        class: 'datatable-pagination',
      },
    },
    tablecontainer: {
      class: 'datatable-container',
    },
    filterelementcontainer: {
      root: {
        class: 'datatable-cell',
      },
    },
    multiselect: {
      root: { class: 'p-multiselect' },
      label: ({ props }) => ({
        class: [
          'p-multiselect-label',
          {
            'p-placeholder': !props.modelValue || props.modelValue.length === 0,
            'p-placeholder-gray-dark': !props.modelValue || props.modelValue.length === 0,
          },
        ],
      }),
      labelContainer: { class: 'p-multiselect-label-container' },
      token: { class: 'p-multiselect-token' },
      chip: { class: 'p-multiselect-chip' },
      trigger: { class: 'p-multiselect-trigger' },
      header: { class: 'p-multiselect-header' },
      wrapper: { class: 'p-multiselect-items p-multiselect-list-container' },
      list: { class: 'p-multiselect-list p-multiselect-items' },
      item: ({ context }) => ({ class: [ 'p-multiselect-item', { 'p-highlight': context.selected, 'p-focus': context.focused, 'p-disabled': context.disabled } ] }),
      option: ({ context }) => ({ class: [ 'p-multiselect-option', { 'p-highlight': context.selected, 'p-focus': context.focused, 'p-disabled': context.disabled } ] }),
      optionLabel: { class: 'p-multiselect-option-label p-multiselect-item-label' },
      checkbox: ({ context }) => ({ class: [ 'p-checkbox', { 'p-highlight': context.selected, 'p-checkbox-checked': context.selected } ] }),
    },
  },
  {
    mergeSections: true,
    mergeProps: false,
  },
);

export const primevueConfig = {
  unstyled: true,
  pt: preset,
};
